import { render, staticRenderFns } from "./DustDetail.vue?vue&type=template&id=6aef85fa&"
import script from "./DustDetail.vue?vue&type=script&lang=js&"
export * from "./DustDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports